import React from 'react';
import { AlertProps, Box, IconButton, Snackbar, Typography, SnackbarProps } from '@mui/material';
import {
  Close as CloseIcon,
  CheckCircle as CheckCircleIcon,
  Warning as WarningIcon,
  Error as ErrorIcon,
  Info as InfoIcon
} from '@mui/icons-material';
import { styles } from './Toast.styles';

const TOAST_TIME_OUT = 5000;

const ToastIconByColor = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon
};

export type ToastProps = {
  title: string;
  body?: string;
  severity: AlertProps['severity'];
  onClose?: () => void;
  snackbarProps?: SnackbarProps;
};

export const Toast = ({ title, body, severity = 'success', onClose, snackbarProps }: ToastProps) => {
  const ToastIcon = ToastIconByColor[severity];

  return (
    <Snackbar
      open={true}
      color={severity}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      autoHideDuration={TOAST_TIME_OUT}
      data-test="toast"
      sx={styles.toast}
      {...snackbarProps}
      onClose={onClose}
    >
      <Box role="alert" sx={styles.toastContent}>
        <ToastIcon sx={styles.toastIcon} data-test={`${severity}Icon`} />
        <Box sx={styles.textContainer}>
          <Typography variant="h5" component="h2" role="heading" aria-level={2}>
            {title}
          </Typography>
          {body ? (
            <Typography variant="bodySmall" className="toast-text" sx={styles.body}>
              {body}
            </Typography>
          ) : null}
        </Box>
        <IconButton className="toast-close" sx={styles.closeButton} aria-label="close" onClick={onClose}>
          <CloseIcon sx={styles.closeIcon} />
        </IconButton>
      </Box>
    </Snackbar>
  );
};
